import { fromJS } from 'immutable/dist/immutable';
import { basicSort } from '../../../../util/sortUtils';
import { refColumns, refSort } from '../../../InfoReduxConstant';

export const CLEAR_MARIGRAM_INFO = 'CLEAR_MARIGRAM_INFO';

export const GET_MARIGRAM_INFO_REFERENCES_REQUEST = 'GET_MARIGRAM_INFO_REFERENCES_REQUEST';
export const GET_MARIGRAM_INFO_REFERENCES_SUCCESS = 'GET_MARIGRAM_INFO_REFERENCES_SUCCESS';
export const GET_MARIGRAM_INFO_REFERENCES_FAILURE = 'GET_MARIGRAM_INFO_REFERENCES_FAILURE';

export const GET_MARIGRAM_INFO_REQUEST = 'GET_MARIGRAM_INFO_REQUEST';
export const GET_MARIGRAM_INFO_SUCCESS = 'GET_MARIGRAM_INFO_SUCCESS';
export const GET_MARIGRAM_INFO_FAILURE = 'GET_MARIGRAM_INFO_FAILURE';

export const MARIGRAM_INFO_REFERENCE_SORT = 'MARIGRAM_INFO_REFERENCE_SORT';
export const MARIGRAM_INFO_TOGGLE_COLUMN = 'MARIGRAM_INFO_TOGGLE_COLUMN';

const initialState = fromJS({
  fetchedMarigram: false,
  marigram: {},
  fetchedReferences: false,
  references: [],

  sort: refSort,
  visibleColumns: refColumns,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const marigramInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_MARIGRAM_INFO:
      return initialState;

    case MARIGRAM_INFO_REFERENCE_SORT:
      return state.merge(fromJS({
        references: basicSort(action.sort, state.get('references')),
        sort: action.sort,
      }));

    case GET_MARIGRAM_INFO_REFERENCES_REQUEST:
      return state.set('fetchedReferences', false);
    case GET_MARIGRAM_INFO_REFERENCES_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case GET_MARIGRAM_INFO_REFERENCES_FAILURE:
      return state.set('fetchedReferences', true);

    case GET_MARIGRAM_INFO_REQUEST:
      return state.set('fetchedMarigram', false);
    case GET_MARIGRAM_INFO_SUCCESS:
      return state.merge(fromJS({
        fetchedMarigram: true,
        marigram: action.response,
      }));
    case GET_MARIGRAM_INFO_FAILURE:
      return state.set('fetchedMarigram', true);

    case MARIGRAM_INFO_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
